module.exports = __webpack_public_path__ + "img/filler_1_mob.9b51fcfe.svg";